import { Modal } from 'antd';
import { fieldDefaultProps } from 'utils/fieldConfig';
import { ReactNode } from 'react';
import './index.css';

interface ConfirmationModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title: string;
  description?: string | ReactNode;
  confirmText?: string;
  cancelText?: string;
  centered?: boolean;
  closeIcon?: boolean;
  dangerConfirm?: boolean;
  loading?: boolean;
}

const ConfirmationModal = ({
  isOpen,
  onClose,
  onConfirm,
  title,
  description,
  confirmText = 'Confirm',
  cancelText = 'Cancel',
  centered = true,
  closeIcon = false,
  dangerConfirm = false,
  loading = false,
}: ConfirmationModalProps) => {
  return (
    <Modal
      open={isOpen}
      onCancel={loading ? undefined : onClose}
      onOk={onConfirm}
      okText={confirmText}
      cancelText={cancelText}
      closeIcon={loading ? false : closeIcon}
      okButtonProps={
        dangerConfirm ? { ...fieldDefaultProps, danger: true, loading } : { ...fieldDefaultProps, loading }
      }
      cancelButtonProps={loading ? { ...fieldDefaultProps, disabled: true } : fieldDefaultProps}
      centered={centered}
      className="confirmation-modal"
      maskClosable={!loading}
      keyboard={!loading}
    >
      <div className="flex flex-col items-center py-2">
        <p className="h4-bold text-primary-600 text-center">{title}</p>
        {description && <p className="mt-6 text-center italic">{description}</p>}
      </div>
    </Modal>
  );
};

export default ConfirmationModal;
